module.exports = __webpack_public_path__ + "static/media/11. Coconut Macaroon 250g.6dd127d0.jpg";